import React from 'react';

// All shapes use a fixed 48×48 viewBox; width/height props scale them.
function renderShape(shape, color) {
  switch (shape) {
    case 'triangle':
      return <polygon points="24,3 45,44 3,44" fill={color} />;
    case 'square':
      return <rect x="4" y="4" width="40" height="40" rx="5" fill={color} />;
    case 'circle':
      return <circle cx="24" cy="24" r="20" fill={color} />;
    case 'pentagon': {
      const pts = Array.from({ length: 5 }, (_, i) => {
        const a = (i * 72 - 90) * (Math.PI / 180);
        return `${24 + 21 * Math.cos(a)},${24 + 21 * Math.sin(a)}`;
      }).join(' ');
      return <polygon points={pts} fill={color} />;
    }
    case 'hexagon': {
      const pts = Array.from({ length: 6 }, (_, i) => {
        const a = (i * 60 - 30) * (Math.PI / 180);
        return `${24 + 21 * Math.cos(a)},${24 + 21 * Math.sin(a)}`;
      }).join(' ');
      return <polygon points={pts} fill={color} />;
    }
    case 'question-mark':
    default:
      return (
        <text
          x="24"
          y="36"
          textAnchor="middle"
          fontSize="36"
          fontWeight="900"
          fill={color}
          fontFamily="Heebo, sans-serif"
        >
          ?
        </text>
      );
  }
}

export default function ShapeRenderer({ shape, color = '#ffffff', size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      {renderShape(shape, color)}
    </svg>
  );
}
